<template>
    <div class="fullHeight">
        <Card
            :page_title="page_title"
            iconclass="icon-icon-info mypage-title-icon"
        >
            <div class="col-sm-12">
                <p>変更期限を過ぎているため、同伴者は変更できません。</p>
                <div v-if="mobileAppHidden === false" class="row no-gutters justify-content-center py-2">
                    <div class="col-sm-4 w-100">
                        <button class="mypagebackbutton footer-btn-size" @click="myPageTop">一覧へ戻る</button>
                    </div>
                </div>
            </div>

        </Card>
    </div>
</template>

<script>
import MypageSideMenu from "./MypageSideMenu";
import Card from '../components/Card';

export default {
    components: {
        MypageSideMenu,
        Card
    },
    data() {
        return {
            page_title: '同伴者変更',
            limitDay: 0,
            // モバイルアプリ非表示フラグ
            mobileAppHidden: false
        };
    },
    created() {
        this.initialize();
    },
    mounted() {
        this.$nextTick(function () {
            this.$store.commit("loading/setIsLoading", false);
        });
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize() {
            this.$store.commit("loading/setIsLoading", true);
            // モバイルアプリか判断する
            if (this.$store.state.auth.mobileAppFlag) {
                // モバイルアプリの場合、遷移ボタンを非表示にする
                this.mobileAppHidden = true;
            } 
        },
        myPageTop: function () {
            this.$router.push({ path: "/mypage-reserve-list" });
        }
    }
};
</script>

<style scoped>
</style>
